export default __webpack_public_path__ + "static/media/Bell.0682085f.mp3";